import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@contexts/LanguageContext';
import { useAuthContext } from '@contexts/AuthContext';
import { BorrowingCalendar } from '@components/BorrowingCalendar';
import './BorrowingsCalendarPage.scss';

export const BorrowingsCalendarPage = () => {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const { user } = useAuthContext();

    const handleSelectEvent = (event) => {
        // Navigate to borrowing details page
        if (event.originalId) {
            navigate(`/borrowings/${event.originalId}`);
        }
    };

    const handleSelectSlot = (slotInfo) => {
        // Could be used to create new borrowings/reservations
        // For now, just log the slot info
        console.log('Selected slot:', slotInfo);
    };

    return (
        <div className="borrowings-calendar-page">
            <div className="borrowings-calendar-page__header">
                <h2 className="borrowings-calendar-page__title">
                    {t('borrowing.calendar.title')}
                </h2>
                <p className="borrowings-calendar-page__description">
                    {t('borrowing.calendar.description')}
                </p>
            </div>

            <div className="borrowings-calendar-page__content">
                <BorrowingCalendar
                    contextModel={user}
                    onSelectEvent={handleSelectEvent}
                    onSelectSlot={handleSelectSlot}
                    fieldTitle='resource'
                    selectable={false}
                    height="1400px"
                    className="borrowings-calendar"
                />
            </div>
        </div>
    );
};

export default BorrowingsCalendarPage;
